// 見出し + 補足 + 右寄せ action (例: 「一覧を見る」リンク) の定型。
// level: 1 (ページタイトル) / 2 (セクション) / 3 (サブセクション)
import type { ReactNode } from "react";

interface Props {
  level?: 1 | 2 | 3;
  subtitle?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function SectionHeading({
  level = 2,
  subtitle,
  action,
  className,
  children,
}: Props) {
  const Tag = (level === 1 ? "h1" : level === 2 ? "h2" : "h3") as
    | "h1"
    | "h2"
    | "h3";
  const titleCls =
    level === 1
      ? "text-4xl md:text-5xl font-bold text-tora-ink tracking-tight"
      : level === 2
        ? "text-3xl md:text-4xl font-bold text-tora-ink tracking-tight"
        : "text-lg md:text-xl font-bold text-tora-ink";
  const wrapMb = level === 1 || level === 2 ? "mb-6 md:mb-8" : "mb-3";
  const showBar = level === 1 || level === 2;
  return (
    <div
      className={`flex items-start gap-3 ${className ?? wrapMb}`.trim()}
    >
      <div className="flex-1 min-w-0">
        <Tag className={titleCls}>{children}</Tag>
        {showBar && (
          <div className="mt-2 w-12 h-1 rounded-full bg-tora" aria-hidden="true" />
        )}
        {subtitle && (
          <p
            className={`${level === 1 || level === 2 ? "text-sm md:text-base" : "text-sm"} text-tora-ink/70 mt-2`}
          >
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
